import React, { FC, PropsWithChildren } from 'react';
import { Fade, ClickAwayListener, Popper, Box, PopperProps } from '@mui/material';


export type DropdownPopperProps = Pick<PopperProps, 'anchorEl' | 'disablePortal' | 'sx'> & {
    isOpen: boolean;
    close: () => void;
}

export const DropdownPopper: FC<PropsWithChildren<DropdownPopperProps>> = ({
    isOpen,
    close,
    anchorEl,
    children,
    disablePortal,
    sx,
}) => (
    <Popper
        open={isOpen}
        anchorEl={anchorEl}
        placement='bottom-start'
        disablePortal={disablePortal}
        sx={{
            zIndex: 42,
            ...sx,
        }}
        modifiers={[
            {
                name: 'offset',
                options: {
                    offset: [0, 8],
                },
            },
            {
                name: 'flip',
                enabled: true,
                options: {
                    fallbackPlacements: [
                        'top-start',
                        'right-start',
                        'right',
                        'right-end',
                        'left-start',
                        'left',
                        'left-end',
                    ],
                },
            },
        ]}
        transition
    >
        {({ TransitionProps }) => (
            <ClickAwayListener onClickAway={close}>
                <Fade {...TransitionProps}>
                    <Box>{children}</Box>
                </Fade>
            </ClickAwayListener>
        )}
    </Popper>
);
